import DivContainerBody from '../../../../../components/DivContainerBody';
import {
    EmailSubsectionChip,
    IconProfileDropDown,
    PersonChip,
    PhoneSubsectionChip,
} from '../../../../../components/buttons/IconButtons';
import PrivilegeDetailsApp from '../Functionality/PrivilegeDetailsApp';
import { getFullName } from '../../../../../Apis/functions';
import CustomSearch from '../../../../../components/SearchSimples/CustomSearch';
import CustomTooltip from '../../../../../components/CustomTooltip';
import CustomCard from './../../../../../components/CustomCard';
import NotInformation from './../../../../../components/NotInformation';
import { AssignedPrivilegeEmployeesApp } from '../Functionality/AssignedPrivilegeDetailsApp';
import AssignedTabResource from '../../../../../components/ResourceAssignment/SubComponents/AssignedTabResource';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const PrivilegeDetails = ({ row }) => {
    
    const {
        searchResults,
        remove,
        setRemove,
        t,
        pagination,
        searchElement,
        setSearchElement,
        selected,
        setSelected,
        selectForDelete,
        setSelectForDelete,
        isAllChecked,
        setIsAllChecked,
        triggerDelete,
        setTriggerDelete,
        results,
        setResults,
        setBodyForExport,
        setSearch,
        setSimpleSearch,
        modified,
        setModified,
    } = PrivilegeDetailsApp(row?.id);

    return (
        <AssignedTabResource
            useAssignedApp={AssignedPrivilegeEmployeesApp}
            resource={'employee'}
            id={row?.id}
            selected={selected}
            setSelected={setSelected}
            selectForDelete={selectForDelete}
            setSelectForDelete={setSelectForDelete}
            isAllChecked={isAllChecked}
            setIsAllChecked={setIsAllChecked}
            triggerDelete={triggerDelete}
            setTriggerDelete={setTriggerDelete}
            searchElement={searchElement}
            setSearchElement={setSearchElement}
            results={results}
            setResults={setResults}
            setBodyForExport={setBodyForExport}
            setSearch={setSearch}
            setSimpleSearch={setSimpleSearch}
            modified={modified}
            setModified={setModified}
            renderModuleTitle={
                <div className='d-flex align-items-center justify-content-start mb-3'>
                    <div>
                        <IconProfileDropDown className='mr-8px mb-1 h-16px w-16px icon-color-general-950' />
                    </div>
                    <div className={`mr-5 flex-grow-1 minw-0 p-0`}>
                        <CustomTooltip
                            text={t('assigned_employees')}
                            classes={`fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row `}
                            showIfTruncated={true}
                        />
                    </div>
                    <div className='background-shades-200 border-full-shades-150 d-flex justify-content-center align-items-center border-radius-8px cursor-pointer minw-18px fs-12px ibl-font-w-500 font-color-shades-500 '>
                        {searchResults?.content?.length || 0}
                    </div>
                    <div className='vertical-separator-shades-950 h-auto' />
                </div>
            }
        />
    );
};

export default PrivilegeDetails;
